export async function urlToFile(url) {
    const response = await fetch(url);
    const blob = await response.blob();

    // Try to extract the filename from the URL
    const filename = url.split('/').pop() || 'default_filename';

    // Use the Blob's MIME type if available, otherwise fallback to a default
    const mimeType = blob.type || 'application/octet-stream';

    return new File([blob], filename, { type: mimeType });
}
